import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0892b8bf&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=0892b8bf&prod&lang=less&scoped=true"
import style1 from "./menu.vue?vue&type=style&index=1&id=0892b8bf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892b8bf",
  null
  
)

export default component.exports